import type { OnInit } from '@angular/core';
import { Component, ElementRef, forwardRef, Input, Renderer2 } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseSelectFormFieldComponent } from '@shared/form-fields/select/base-select-form-field.component';
import { ApiParams } from '@shared/http/api-params';
import type { TaxType } from '@shared/modules/tax-types/tax-type';
import { TaxTypeFetcher } from '../tax-type.fetcher';
import { TaxTypePresenter } from '../tax-type.presenter';

@Component({
    selector: 'app-tax-type-select',
    styleUrls: ['./tax-type-select.component.scss'],
    templateUrl: '../../../form-fields/select/select-form-field.component.html',
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TaxTypeSelectComponent), multi: true }],
})
export class TaxTypeSelectComponent extends BaseSelectFormFieldComponent<string> implements OnInit {
    @Input() params: ApiParams;

    constructor(element: ElementRef,
                renderer: Renderer2,
                private fetcher: TaxTypeFetcher) {
        super(element, renderer);
    }

    ngOnInit(): void {
        super.ngOnInit();

        this._fetch();
    }

    private _fetch() {
        const params = {
            ...this.params
        };

        this.fetcher.all(params).subscribe(response => {
            this.apiOptions = TaxTypePresenter.attach(response.data).map((taxType: TaxType) => ({
                label: taxType.name,
                value: taxType.id
            }));
        });
    }
}
